const mainNav = document.querySelector('.footer-row--main');
const mainNavItems = mainNav.querySelectorAll('.footer-navigation__link');

mainNavItems.forEach(function(item) {
	item.addEventListener('mouseover', function() {
		item.classList.toggle('faded--active');

		mainNavItems.forEach(function(nonActiveItems) {
			nonActiveItems.classList.toggle('faded');
		});
	});

	item.addEventListener('mouseout', function() {
		item.classList.toggle('faded--active');

		mainNavItems.forEach(function(nonActiveItems) {
			nonActiveItems.classList.toggle('faded');
		});
	});
});

const metaNav = document.querySelector('.footer-row--meta');
const metaNavItems = metaNav.querySelectorAll('.footer-navigation__link');

metaNavItems.forEach(function(item) {
	item.addEventListener('mouseover', function() {
		item.classList.toggle('faded--active');

		metaNavItems.forEach(function(nonActiveItems) {
			nonActiveItems.classList.toggle('faded');
		});
	});

	item.addEventListener('mouseout', function() {
		item.classList.toggle('faded--active');

		metaNavItems.forEach(function(nonActiveItems) {
			nonActiveItems.classList.toggle('faded');
		});
	});
});
